<template>
  <f7-list inline-labels>
    <f7-block-title>{{$t('title.dateRange')}}</f7-block-title>
    <f7-list-input :label="$t('label.from')" :input="false">
      <div class="month-select" slot="input">
        <f7-input type="select" :value="dataValue.fromMonth"
                  @input="dataValue.fromMonth = parseInt($event.target.value)"
        >
          <option value="" disabled>{{$t('option.month')}}</option>
          <option v-for="(month, index) in months" :key="index" :value="index+1">{{month}}</option>
        </f7-input>
        <f7-input type="select" :value="dataValue.fromYear"
                  @input="dataValue.fromYear = parseInt($event.target.value)"
        >
          <option value="" disabled>{{$t('option.year')}}</option>
          <option v-for="year in years" :key="year" :value="year">{{year}}</option>
        </f7-input>
      </div>
    </f7-list-input>
    <f7-list-input :label="$t('label.toDate')" :input="false">
      <div class="month-select" slot="input">
        <f7-input type="select" :value="dataValue.toMonth" @input="dataValue.toMonth = parseInt($event.target.value)">
          <option value="" disabled>{{$t('option.month')}}</option>
          <option v-for="(month, index) in months" :key="index" :value="index+1">{{month}}</option>
        </f7-input>
        <f7-input type="select" :value="dataValue.toYear" @input="dataValue.toYear = parseInt($event.target.value)">
          <option value="" disabled>{{$t('option.year')}}</option>
          <option v-for="year in years" :key="year" :value="year">{{year}}</option>
        </f7-input>
      </div>
    </f7-list-input>
  </f7-list>
</template>

<script>
  import helpers from '@/utils/helpers'
  import moment from 'moment'

  export default {
    name: 'ReportFilter',
    mixins: [helpers],
    props: {
      value: {
        type: Object,
        default () {
          return {
            fromMonth: 1,
            fromYear: 2016,
            toMonth: moment().month() + 1,
            toYear: moment().year(),
          }
        },
      },
    },
    data () {
      return {
        dataValue: {
          fromMonth: this.value.fromMonth,
          fromYear: this.value.fromYear,
          toMonth: this.value.toMonth,
          toYear: this.value.toYear,
        },
      }
    },
    computed: {
      months () {
        return moment.months()
      },
      years () {
        // would love to find something like python's range function to replace this.
        const years = []
        for (let i = 2016; i <= moment().year(); i++) {
          years.push(i)
        }
        return years
      },
    },
    watch: {
      dataValue: {
        deep: true,
        immediate: true,
        handler () {
          this.$emit('input', this.dataValue)
        },
      },
    },
  }
</script>

<style lang="scss" scoped>

  .month-select {
    display: flex;
    flex-direction: row;

    & > * {
      flex-grow: 1;
    }
  }

</style>
